// extracted by mini-css-extract-plugin
export default {"root":"JournalChart_root__qn6YW","root_area":"JournalChart_root_area__hZGSN"};